/*
 * Bumped after every configuration change, by the settings API clients and by
 * the prototype's sample change log; every ConfigChangeLog on the page watches
 * it and reloads.
 */
import { ref } from "vue";

export const configVersion = ref(0);
export const configChanged = () => {
  configVersion.value++;
};
